export default __webpack_public_path__ + "static/media/icon_articles.a27e0da1.svg";